import { useMemo } from 'react';

// This is the amount that will actually be charged now, it drives the stripe payment block
// The deposit amount and the full amount do not carry the same vakario fee
const useCalcAmountToPay = (checkoutData, totalPrice, isDepositSelected) => {
  return useMemo(() => {
    if (checkoutData == null || totalPrice == null) return null;

    const isFeeIncluded = checkoutData.vakario_fee_included !== false;

    if (isDepositSelected && checkoutData.payment_amount != null) {
      const depositFee = isFeeIncluded ? 0 : parseFloat(checkoutData.vakario_fee ?? 0);
      return parseFloat(checkoutData.payment_amount) + depositFee;
    }

    const fullFee = isFeeIncluded ? 0 : parseFloat(checkoutData.vakario_fee_full ?? 0);
    return parseFloat(totalPrice.tax_included) + fullFee;
  }, [JSON.stringify(checkoutData), JSON.stringify(totalPrice), isDepositSelected]);
};

export default useCalcAmountToPay;
